// Browser shim for 'fs-extra' used by legacy code.
export * from './fs';
import fsDefault from './fs';
export default fsDefault;
